import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param data Object
 * @param organisation OrganisationModel
 * @param serviceEntryModel ServiceEntryModel
 * @return {Promise<any>|Promise}
 */
export default (function (data, organisation, serviceEntryModel) {
    var url = applyPathVariables(EndPoints.SERVICE_ENTRY_TO_IN_PROGRESS, {
        organisationId: organisation.id,
        serviceEntryId: serviceEntryModel.serviceEntryId
    });
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, data: data });
    return request.execute();
});
